import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const InlineFormContainer = styled.div<{ overlay: boolean }>(
    {
        position: "relative",
    },
    props => ({
        ...theme(props).typography.primary.css(),
    }),
    props =>
        props.overlay && {
            "::before": {
                content: '""',
                position: "absolute",
                backgroundColor: props.theme.candy.loadingOverlayBackgroundColor,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
            },
        }
);
